/**
 * Copy for My Favorites, exported as constants so both platform containers render the same
 * words and the Jest specs assert those constants rather than duplicated literals - the same
 * reason `components/OrderShareSheet/copy.ts` exists.
 *
 * Before JSAD-5995 every one of these strings was written out twice, once in the native modal
 * and once in the web drawer, and they had already drifted.
 *
 * The build-summary vocabulary is NOT here: it lives in `lib/entities/Bookmark.ts` next to the
 * pure function that assembles it, so a lib-layer module never has to import from components.
 */

// ── Chrome ───────────────────────────────────────────────────────────────────────────────
export const FAVORITES_TITLE = 'My Favorites';
export const FAVORITES_CLOSE_LABEL = 'Close favorites';
export const FAVORITES_ENTRY_LABEL = 'View favorites';

// ── Sections ─────────────────────────────────────────────────────────────────────────────
export const FAVORITES_AVAILABLE_SECTION = 'Available here';
export const FAVORITES_UNAVAILABLE_SECTION = 'No longer available';

// ── Unavailable rows ─────────────────────────────────────────────────────────────────────
/** Named store when one is selected; the generic form covers "no store yet". */
export const favoritesUnavailableAt = (storeName?: string) =>
    storeName ? `Not available at ${storeName}` : 'Not available at this location';

export const FAVORITES_UNAVAILABLE_HINT =
    'This favorite is not on the menu at your selected location, so it cannot be ordered right now.';

// ── Loading ──────────────────────────────────────────────────────────────────────────────
export const FAVORITES_LOADING_LABEL = 'Loading your favorites';

// ── Empty: never favorited anything ──────────────────────────────────────────────────────
export const FAVORITES_EMPTY_TITLE = 'No favorites yet';
export const FAVORITES_EMPTY_BODY =
    "Tap the star on any item to save it here — we'll keep your customizations too.";

// ── Every favorite is unavailable at this store ──────────────────────────────────────────
export const FAVORITES_ALL_UNAVAILABLE_TITLE = 'Nothing available here';
export const FAVORITES_ALL_UNAVAILABLE_BODY =
    'None of your favorites are on the menu at this location. Try another store, or keep them for next time.';
export const FAVORITES_CHANGE_STORE_LABEL = 'Change location';

// ── Star ─────────────────────────────────────────────────────────────────────────────────
export const FAVORITES_SAVE_LABEL = 'Save to favorites';
export const FAVORITES_REMOVE_LABEL = 'Remove from favorites';
export const FAVORITES_REMOVE_HINT = 'Removes this item from your favorites';
export const FAVORITES_OPEN_HINT = 'Opens this favorite, ready to add to your bag';
export const FAVORITES_ADDED_TOAST = 'Added to favorites';
export const FAVORITES_REMOVED_TOAST = 'Removed from favorites';
/** Order History hint under "Your order", for guests who have not found the star yet (JSAD-7305). */
export const FAVORITES_TAP_STAR_HINT = 'Tap star to favorite';

// ── Share ────────────────────────────────────────────────────────────────────────────────
/** The header button reuses the order-detail share sheet (JSAD-7305). */
export const FAVORITES_SHARE_ENTRY_LABEL = 'Share your favorites';
export const FAVORITES_SHARE_ENTRY_HINT =
    'Opens a list of your favorites, each with a link you can share';
